import { BorderRadius, Color, getDefaultTransition, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  width: 100%;
  margin-top: ${Spacing.S4}; /* helper for search border to not be cut by module's overflow */
  margin-bottom: ${Spacing.S12};
`

export const SearchWrapper = styled.div`
  display: flex;
  align-items: stretch;
  flex: 1;
  min-width: 0;
  height: 40px;
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.RFull};
  ${getDefaultTransition('border-color')};

  &:hover,
  &:focus-within {
    border-color: ${Color.Grey400};
  }
`

export const FiltersButtonWrapper = styled.div`
  display: flex;
  align-self: stretch;
  flex-direction: column;

  > button {
    flex: 1;
  }
`

export const ColumnVisibilityWrapper = styled.div`
  flex-shrink: 0;
`
